var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.307 5.431a1.874 1.874 0 0 0-1.132-1.281C14.497 3.116 10.235 3.125 10 3.125c-.234 0-4.497-.01-7.175 1.025a1.875 1.875 0 0 0-1.132 1.281c-.202.78-.443 2.205-.443 4.569s.24 3.79.443 4.569a1.876 1.876 0 0 0 1.132 1.282c2.566.99 6.581 1.024 7.123 1.024h.104c.542 0 4.56-.034 7.123-1.024a1.875 1.875 0 0 0 1.132-1.282c.202-.782.443-2.205.443-4.569s-.24-3.79-.443-4.569Zm-5.634 4.83-3.75 2.5a.312.312 0 0 1-.486-.261v-5a.312.312 0 0 1 .486-.26l3.75 2.5a.312.312 0 0 1 0 .52Z",
  fill: "#2C4145"
})));
export default SvgSocialYoutube;